import { render, staticRenderFns } from "./addBooksList.vue?vue&type=template&id=08fc8964"
import script from "./addBooksList.vue?vue&type=script&lang=js"
export * from "./addBooksList.vue?vue&type=script&lang=js"
import style0 from "./addBooksList.vue?vue&type=style&index=0&id=08fc8964&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports